import React, { useState } from "react";
import ReactMarkdown from 'react-markdown';
import { Badge } from "./UI";
import { CARD_BASE, IMAGE_THUMBNAIL } from "../styles/classNames";
import { useToast } from "./Toast";
import { LEAD_STATUSES, LEAD_PRIORITIES, CONTACT_TYPES } from "../constants/leads";

// Contact icons components
const TelegramIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="20" height="20">
    <path fill="#29b6f6" d="M24 4A20 20 0 1 0 24 44A20 20 0 1 0 24 4Z"/>
    <path fill="#fff" d="M33.95,15l-3.746,19.126c0,0-0.161,0.874-1.245,0.874c-0.576,0-0.873-0.274-0.873-0.274l-8.114-6.733 l-3.97-2.001l-5.095-1.355c0,0-0.907-0.262-0.907-1.012c0-0.625,0.933-0.923,0.933-0.923l21.316-8.468 c-0.001-0.001,0.651-0.235,1.126-0.234C33.667,14,34,14.125,34,14.5C34,14.75,33.95,15,33.95,15z"/>
    <path fill="#b0bec5" d="M23,30.505l-3.426,3.374c0,0-0.149,0.115-0.348,0.12c-0.069,0.002-0.143-0.009-0.219-0.043 l0.964-5.965L23,30.505z"/>
    <path fill="#cfd8dc" d="M29.897,18.196c-0.169-0.22-0.481-0.26-0.701-0.093L16,26c0,0,2.106,5.892,2.427,6.912 c0.322,1.021,0.58,1.045,0.58,1.045l0.964-5.965l9.832-9.096C30.023,18.729,30.064,18.416,29.897,18.196z"/>
  </svg>
);

const WhatsAppIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="20" height="20">
    <path fill="#fff" d="M4.868,43.303l2.694-9.835C5.9,30.59,5.026,27.324,5.027,23.979C5.032,13.514,13.548,5,24.014,5c5.079,0.002,9.845,1.979,13.43,5.566c3.584,3.588,5.558,8.356,5.556,13.428c-0.004,10.465-8.522,18.98-18.986,18.98c-0.001,0,0,0,0,0h-0.008c-3.177-0.001-6.3-0.798-9.073-2.311L4.868,43.303z"/>
    <path fill="#40c351" d="M35.176,12.832c-2.98-2.982-6.941-4.625-11.157-4.626c-8.704,0-15.783,7.076-15.787,15.774c-0.001,2.981,0.833,5.883,2.413,8.396l0.376,0.597l-1.595,5.821l5.973-1.566l0.577,0.342c2.422,1.438,5.2,2.198,8.032,2.199h0.006c8.698,0,15.777-7.077,15.78-15.776C39.795,19.778,38.156,15.814,35.176,12.832z"/>
    <path fill="#fff" fillRule="evenodd" d="M19.268,16.045c-0.355-0.79-0.729-0.806-1.068-0.82c-0.277-0.012-0.593-0.011-0.909-0.011c-0.316,0-0.83,0.119-1.265,0.594c-0.435,0.475-1.661,1.622-1.661,3.956c0,2.334,1.7,4.59,1.937,4.906c0.237,0.316,3.282,5.259,8.104,7.161c4.007,1.58,4.823,1.266,5.693,1.187c0.87-0.079,2.807-1.147,3.202-2.255c0.395-1.108,0.395-2.057,0.277-2.255c-0.119-0.198-0.435-0.316-0.909-0.554s-2.807-1.385-3.242-1.543c-0.435-0.158-0.751-0.237-1.068,0.238c-0.316,0.474-1.225,1.543-1.502,1.859c-0.277,0.317-0.554,0.357-1.028,0.119c-0.474-0.238-2.002-0.738-3.815-2.354c-1.41-1.257-2.362-2.81-2.639-3.285c-0.277-0.474-0.03-0.731,0.208-0.968c0.213-0.213,0.474-0.554,0.712-0.831c0.237-0.277,0.316-0.475,0.474-0.791c0.158-0.317,0.079-0.594-0.04-0.831C20.612,19.329,19.69,16.983,19.268,16.045z" clipRule="evenodd"/>
  </svg>
);

const WeChatIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="20" height="20">
    <path fill="#8BC34A" d="M18,6C9.2,6,2,12,2,19.5c0,4.3,2.3,8,6,10.5l-2,6l6.3-3.9C14,32.7,16,33,18,33c8.8,0,16-6,16-13.5C34,12,26.8,6,18,6z"/>
    <path fill="#7CB342" d="M20,29c0-6.1,5.8-11,13-11c0.3,0,0.6,0,0.9,0c-0.1-0.7-0.3-1.4-0.5-2c-0.1,0-0.3,0-0.4,0c-8.3,0-15,5.8-15,13c0,1.4,0.3,2.7,0.7,4c0.7,0,1.4-0.1,2.1-0.2C20.3,31.6,20,30.3,20,29z"/>
    <path fill="#CFD8DC" d="M46,29c0-6.1-5.8-11-13-11c-7.2,0-13,4.9-13,11s5.8,11,13,11c1.8,0,3.5-0.3,5-0.8l5,2.8l-1.4-4.8C44.3,35.2,46,32.3,46,29z"/>
    <path fill="#33691E" d="M14,15c0,1.1-0.9,2-2,2s-2-0.9-2-2s0.9-2,2-2S14,13.9,14,15z M24,13c-1.1,0-2,0.9-2,2s0.9,2,2,2s2-0.9,2-2S25.1,13,24,13z"/>
    <path fill="#546E7A" d="M30,26.5c0,0.8-0.7,1.5-1.5,1.5S27,27.3,27,26.5s0.7-1.5,1.5-1.5S30,25.7,30,26.5z M37.5,25c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5S38.3,25,37.5,25z"/>
  </svg>
);

const EmailIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="4" width="20" height="16" rx="2"/>
    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
  </svg>
);

const PhoneIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
  </svg>
);

const getContactIcon = (type) => {
  switch(type) {
    case 'telegram': return <TelegramIcon />;
    case 'whatsapp': return <WhatsAppIcon />;
    case 'wechat': return <WeChatIcon />;
    case 'email': return <EmailIcon />;
    case 'phone': return <PhoneIcon />;
    default: return null;
  }
};

/**
 * Компонент карточки лида
 */
export function LeadCard({ lead, onEdit, onDelete, readOnly = false, showManager = false }) {
  const hasPhotos = lead.photoDataUrls && lead.photoDataUrls.length > 0;
  const [fullscreenPhoto, setFullscreenPhoto] = useState(null);
  const toast = useToast();

  return (
    <div className={`${CARD_BASE} flex flex-col md:flex-row gap-4`}>
      {/* Фото - показываем только если есть, квадратики в один ряд */}
      {hasPhotos && (
        <div className="w-full md:w-auto">
          <div className="flex gap-2">
            {lead.photoDataUrls.slice(0, 3).map((url, idx) => (
              <div key={idx} className="relative">
                <img 
                  src={url} 
                  alt={`${lead.name} ${idx + 1}`} 
                  className="w-20 h-20 object-cover rounded-lg cursor-pointer hover:opacity-80 transition-opacity"
                  loading="lazy"
                  onClick={() => setFullscreenPhoto(url)}
                  onError={(e) => {
                    // Обработка ошибок загрузки (S3 URL мог истечь)
                    e.target.onerror = null;
                    e.target.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="100" height="100"%3E%3Crect fill="%23ddd" width="100" height="100"/%3E%3Ctext fill="%23999" x="50%25" y="50%25" text-anchor="middle" dy=".3em"%3EФото недоступно%3C/text%3E%3C/svg%3E';
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Основная информация */}
      <div className="flex-1">
        <div className="flex flex-wrap items-center gap-2 mb-1">
          <div className="text-lg font-semibold">{lead.name}</div>
          <Badge>{lead.company || "без компании/команды"}</Badge>
          <Badge>{lead.event}</Badge>
        </div>
        
        <div className="text-sm text-gray-600 dark:text-gray-400 break-words">
          {lead.contact}
        </div>

        {/* Contact icons row */}
        {CONTACT_TYPES.some(ct => lead[ct.key]) && (
          <div className="flex flex-wrap gap-2 mt-2">
            {CONTACT_TYPES.map(ct => {
              const value = lead[ct.key];
              if (!value) return null;
              return (
                <button
                  key={ct.key}
                  onClick={() => {
                    navigator.clipboard.writeText(value);
                    toast.success(`${ct.label} copied!`);
                  }}
                  className="flex items-center gap-1 px-2 py-1 rounded-lg bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors text-xs"
                  title={`${ct.label}: ${value} (click to copy)`}
                >
                  {getContactIcon(ct.icon)}
                  <span className="max-w-[100px] truncate">{value}</span>
                </button>
              );
            })}
          </div>
        )}
        
        <div className="flex flex-wrap gap-2 mt-2">
          {/* Lead Status */}
          {lead.status && (
            <Badge>
              {LEAD_STATUSES.find(s => s.value === lead.status)?.label || lead.status}
            </Badge>
          )}
          {/* Priority */}
          {lead.priority && (
            <Badge>
              {LEAD_PRIORITIES.find(p => p.value === lead.priority)?.label || lead.priority}
            </Badge>
          )}
          <Badge>
            Тип: {lead.leadType === "Other" ? (lead.customLeadType || "Other") : lead.leadType}
          </Badge>
          <Badge>
            Источник: {
              Array.isArray(lead.trafficSource) 
                ? lead.trafficSource.map(s => s === "Other" ? (lead.customTraffic || "Other") : s).join(", ")
                : (lead.trafficSource === "Other" ? (lead.customTraffic || "Other") : lead.trafficSource)
            }
          </Badge>
          <Badge>
            Статус: {lead.worksWithUs === "yes" ? "уже с нами" : lead.worksWithUs === "no" ? "пока нет" : "не уверен"}
          </Badge>
          {(lead.commissionModel || lead.customCommission) && (
            <Badge>
              Комиссия: {lead.commissionModel === "Other" ? (lead.customCommission || "Other") : lead.commissionModel}
            </Badge>
          )}
        </div>
        
        {lead.notes && (
          <div className="mt-2 text-sm prose prose-sm dark:prose-invert max-w-none">
            <ReactMarkdown>{lead.notes}</ReactMarkdown>
          </div>
        )}
        
        <div className="mt-3 flex justify-between items-center text-xs text-gray-500 dark:text-gray-400">
          <div>
            {lead.createdAt ? new Date(lead.createdAt).toLocaleString(undefined, { 
              year: 'numeric', 
              month: '2-digit', 
              day: '2-digit', 
              hour: '2-digit', 
              minute: '2-digit'
            }) : ""}
          </div>
          <div className="flex items-center gap-2">
            {showManager && lead.managerName && (
              <div>
                {lead.managerName}
              </div>
            )}
            {!readOnly && onEdit && onDelete && (
              <div className="flex gap-2">
                <button 
                  onClick={() => onEdit(lead.id)} 
                  className="w-8 h-8 flex items-center justify-center rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
                  title="Редактировать"
                >
                  ✏️
                </button>
                <button 
                  onClick={() => onDelete(lead.id)} 
                  className="w-8 h-8 flex items-center justify-center rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
                  title="Удалить"
                >
                  🗑
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Fullscreen photo modal */}
      {fullscreenPhoto && (
        <div 
          className="fixed inset-0 z-50 bg-black bg-opacity-90 flex items-center justify-center p-4"
          onClick={() => setFullscreenPhoto(null)}
        >
          <button 
            className="absolute top-4 right-4 text-white text-4xl font-bold hover:opacity-70 transition-opacity"
            onClick={() => setFullscreenPhoto(null)}
            title="Закрыть"
          >
            ✕
          </button>
          <img 
            src={fullscreenPhoto} 
            alt="Fullscreen view" 
            className="max-w-full max-h-full object-contain"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </div>
  );
}
